// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBar {
    display: flex;
    justify-content:space-between;
    width: 100%;
    height: 60px;
    /* border: 1px solid red; */
    /* margin-left: 0.27vw; */
    background-color: #F2F2F2;

    /* box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.05); */  
    
}

.hello {
    display: flex;
    flex-direction: row;
}
.navProfileSide{
    align-items: center;
    display: flex;
    padding-right: 50px;
    gap: 20px;
}

.profile_pic {
    /* padding: 12; */
    background-color: rgb(187, 187, 187);
    border-radius: 50%;
    width: 2.5vw;
    height: 5vh;
    /* margin-top: 2vh; */
    /* margin-right: 0.3vw; */
}

.icon{
  cursor: pointer;
}

.notifications {
    /* max-height: 200px;
    overflow:scroll; */
    position: absolute;
    top: 60px;
    right: 0;
    background-color: white;
    color: black;
    font-weight: 300;
    /* padding: 10px; */
    /* border-radius: 14px; */
    width: 395px;
    height: 260px;
    transform: translateX(-90px);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    z-index: 999;
  }
  .notifications-extend{
    height: 360px;
  }
  .notifications-tab{
    height: 116px;
    overflow:scroll;
    display: flex;
    flex-direction: column;
   
  }

  .notifications-tab::-webkit-scrollbar {
    display: none;
  }

  .notifications-tab-extend{
    height: 216px;
  }

  .admin_header_dropdown{
    cursor: pointer;
  }
  
  .nButton {
    width: 100%;
    padding: 10px;
    padding-left: 15px;
    background-color: white;
    text-align: left;
    color: black;
    border: 0;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
  }
  .close_notification{
    margin-left: 210px;
    cursor: pointer;
  }


  .notification_header{
    /* width: 100%; */
    background: #555759;
    /* border-radius: 14px 14px 0px 0px; */
    height: 48px;
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    color: #FFFFFF;
  }
  .day_select_tab{
    padding: 12px 0px 0px 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
  }
  .active_day{
    color: #3174A4;
    margin-right: 12px;
    padding-bottom: 9px;
    border-bottom: 2px solid #3174A4;
    cursor: pointer;
  }
.not_active_day{
  color: rgba(0, 0, 0, 0.39);
  margin-right: 12px;
  cursor: pointer;
}
.border_day_select{
  color: rgba(0, 0, 0, 0.25);
}
/* .notification_length{
  border-radius: 100%;
  background: rgba(169, 200, 106, 0.26);
} */


.notification_row{
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-left: 16px;
  padding-right: 12px;
}
.new_notification_circle{
  height: 9px;
  width: 9px;
  background-color: #FF7172;;
  border-radius: 50%;
  display: inline-block;
  transform: translateY(15px) translateX(-12px);
}
.notification_box{
  width: 270px;
  height: 58px;
  font-size: 13px;
}
.notification {
  font-size: 11px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 12px;
  font-style: normal;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.53);
}
.notification_time{
font-style: normal;
font-weight: 400;
font-size: 10px;
color: rgba(0, 0, 0, 0.53);
}
.car_notification_image{
margin-right: 4px;
}
.car_notification_image img{
  transform: scale(1.4);
}
.today_older_notifications{
  padding-bottom: 10px;
  font-size: 14px;
  margin-top: 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.53);
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Headers/MainHeader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;;IAEzB,mDAAmD;;AAEvD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI;sBACkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,2CAA2C;IAC3C,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;;EAExB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;;;EAGA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;EACjB;AACF;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;;;GAGG;;;AAGH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;AACA,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,0BAA0B;AAC1B;AACA;AACA,iBAAiB;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB","sourcesContent":[".topBar {\r\n    display: flex;\r\n    justify-content:space-between;\r\n    width: 100%;\r\n    height: 60px;\r\n    /* border: 1px solid red; */\r\n    /* margin-left: 0.27vw; */\r\n    background-color: #F2F2F2;\r\n\r\n    /* box-shadow: 20px 0px 24px rgba(0, 0, 0, 0.05); */  \r\n    \r\n}\r\n\r\n.hello {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n.navProfileSide{\r\n    align-items: center;\r\n    display: flex;\r\n    padding-right: 50px;\r\n    gap: 20px;\r\n}\r\n\r\n.profile_pic {\r\n    /* padding: 12; */\r\n    background-color: rgb(187, 187, 187);\r\n    border-radius: 50%;\r\n    width: 2.5vw;\r\n    height: 5vh;\r\n    /* margin-top: 2vh; */\r\n    /* margin-right: 0.3vw; */\r\n}\r\n\r\n.icon{\r\n  cursor: pointer;\r\n}\r\n\r\n.notifications {\r\n    /* max-height: 200px;\r\n    overflow:scroll; */\r\n    position: absolute;\r\n    top: 60px;\r\n    right: 0;\r\n    background-color: white;\r\n    color: black;\r\n    font-weight: 300;\r\n    /* padding: 10px; */\r\n    /* border-radius: 14px; */\r\n    width: 395px;\r\n    height: 260px;\r\n    transform: translateX(-90px);\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\r\n    z-index: 999;\r\n  }\r\n  .notifications-extend{\r\n    height: 360px;\r\n  }\r\n  .notifications-tab{\r\n    height: 116px;\r\n    overflow:scroll;\r\n    display: flex;\r\n    flex-direction: column;\r\n   \r\n  }\r\n\r\n  .notifications-tab::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  .notifications-tab-extend{\r\n    height: 216px;\r\n  }\r\n\r\n  .admin_header_dropdown{\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .nButton {\r\n    width: 100%;\r\n    padding: 10px;\r\n    padding-left: 15px;\r\n    background-color: white;\r\n    text-align: left;\r\n    color: black;\r\n    border: 0;\r\n    border-radius: 5px;\r\n    margin-top: 10px;\r\n    cursor: pointer;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 11px;\r\n  }\r\n  .close_notification{\r\n    margin-left: 210px;\r\n    cursor: pointer;\r\n  }\r\n\r\n\r\n  .notification_header{\r\n    /* width: 100%; */\r\n    background: #555759;\r\n    /* border-radius: 14px 14px 0px 0px; */\r\n    height: 48px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 19px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 20px;\r\n    color: #FFFFFF;\r\n  }\r\n  .day_select_tab{\r\n    padding: 12px 0px 0px 20px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 13px;\r\n  }\r\n  .active_day{\r\n    color: #3174A4;\r\n    margin-right: 12px;\r\n    padding-bottom: 9px;\r\n    border-bottom: 2px solid #3174A4;\r\n    cursor: pointer;\r\n  }\r\n.not_active_day{\r\n  color: rgba(0, 0, 0, 0.39);\r\n  margin-right: 12px;\r\n  cursor: pointer;\r\n}\r\n.border_day_select{\r\n  color: rgba(0, 0, 0, 0.25);\r\n}\r\n/* .notification_length{\r\n  border-radius: 100%;\r\n  background: rgba(169, 200, 106, 0.26);\r\n} */\r\n\r\n\r\n.notification_row{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  padding-left: 16px;\r\n  padding-right: 12px;\r\n}\r\n.new_notification_circle{\r\n  height: 9px;\r\n  width: 9px;\r\n  background-color: #FF7172;;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  transform: translateY(15px) translateX(-12px);\r\n}\r\n.notification_box{\r\n  width: 270px;\r\n  height: 58px;\r\n  font-size: 13px;\r\n}\r\n.notification {\r\n  font-size: 11px;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  margin-top: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  color: rgba(0, 0, 0, 0.53);\r\n}\r\n.notification_time{\r\nfont-style: normal;\r\nfont-weight: 400;\r\nfont-size: 10px;\r\ncolor: rgba(0, 0, 0, 0.53);\r\n}\r\n.car_notification_image{\r\nmargin-right: 4px;\r\n}\r\n.car_notification_image img{\r\n  transform: scale(1.4);\r\n}\r\n.today_older_notifications{\r\n  padding-bottom: 10px;\r\n  font-size: 14px;\r\n  margin-top: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 11px;\r\n  color: rgba(0, 0, 0, 0.53);\r\n  margin-left: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
